import { graphql } from '@/generated';

export const siteQuery = graphql(`
  query site(
    $orderBy: [SiteOrderBy!]!
    $where: SiteBoolExp!
    $limit: Int!
    $offset: Int!
  ) {
    site(orderBy: $orderBy, where: $where, limit: $limit, offset: $offset) {
      id
      name
      config
      geometry
      customer {
        name
      }
      userData
    }
    siteAggregate(where: $where) {
      aggregate {
        count
      }
    }
  }
`);

export const allCustomerQuery = graphql(`
  query allCustomer {
    customer(orderBy: { name: ASC }) {
      id
      name
      config
      sites(limit: 1) {
        config
      }
    }
  }
`);

export const siteByPkQuery = graphql(`
  query siteByPk($id: uuid!) {
    siteByPk(id: $id) {
      id
      name
      config
      geometry
      devices {
        id
        name
        serial
        products
        config
      }
      customer {
        id
        name
      }
      devicesAggregate {
        aggregate {
          count
        }
      }
      userData
      customerId
    }
  }
`);

export const unassignedDeviceQuery = graphql(`
  query unassignedDevice {
    device(where: { siteId: { _isNull: true } }) {
      id
      name
      serial
      products
      siteId
    }
    deviceAggregate(where: { siteId: { _isNull: true } }) {
      aggregate {
        count
      }
    }
  }
`);
